<template>
  <div>
    <phone
      v-show="!edit"
      @toEdit="toEdit"
    ></phone>
    <password
      v-show="edit"
      :codeCheck="codeCheck"
    ></password>
  </div>
</template>

<script>
  import phone from './children/phone.vue'
  import password from './children/password.vue'
  export default {
    data: function () {
      return {
        codeCheck: '',
        edit: false
      }
    },
    components: {
      phone,
      password
    },
    methods: {
      toEdit: function (codeCheck) {
        this.codeCheck = codeCheck
        this.edit = true
      }
    }
  }
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/ForGetPassword/ForGetPassword.vue